import BaseAlert from '@material-ui/lab/Alert'

const Alert = BaseAlert

export default Alert
